import React, { useRef, useEffect } from "react";
import { animate } from 'animejs';
import "./SkillCard.css";

const SkillCard = ({ name, icon, svg_icon, customClass }) => {
  const cardRef = useRef(null);
  const iconRef = useRef(null);
  const nameRef = useRef(null);

  useEffect(() => {
    const card = cardRef.current;
    const icon = iconRef.current;
    const nameElement = nameRef.current;

    const handleMouseEnter = () => {
      animate(card, {
        translateY: -5,
        borderColor: "rgba(156, 107, 255, 0.8)",
        boxShadow: "0 5px 15px rgba(156, 107, 255, 0.3)",
        duration: 300,
        easing: "easeOutQuad",
      });

      animate(icon, {
        translateY: -8,
        duration: 300,
        easing: "easeOutQuad",
      });

      animate(nameElement, {
        translateY: 0,
        duration: 300,
        easing: "easeOutQuad",
      });
    };

    const handleMouseLeave = () => {
      animate(card, {
        translateY: 0,
        borderColor: "rgba(156, 107, 255, 0.3)",
        boxShadow: "0 0 0 rgba(156, 107, 255, 0)",
        duration: 300,
        easing: "easeOutQuad",
      });

      animate(icon, {
        translateY: 0,
        duration: 300,
        easing: "easeOutQuad",
      });

      animate(nameElement, {
        translateY: 30,
        duration: 300,
        easing: "easeOutQuad",
      });
    };

    if (card) {
      card.addEventListener("mouseenter", handleMouseEnter);
      card.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (card) {
        card.removeEventListener("mouseenter", handleMouseEnter);
        card.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [svg_icon]);

  return (
    <div className="skill-card" ref={cardRef}>
      <div className="skill-icon" ref={iconRef}>
        {svg_icon ? (
          typeof svg_icon === "function" ? (
            React.createElement(svg_icon, { className: `svg-icon ${customClass || ""}` })
          ) : typeof svg_icon === "string" ? (
            <img 
              src = {svg_icon}
              alt={`${name} icon`}
              className={`svg-icon ${customClass ||""}`} />
          ) : (
            <i className={icon}></i>
          )
        ) : (
          <i className={icon}></i>
        )
        }
      </div>
      <div className="skill-name" ref={nameRef}>
        {name}
      </div>
    </div>
  );
};

export default SkillCard;
